class InvalidJSONFormatError extends Error {

  private readonly json: {[index: string]: any};

  constructor(message: string, json: {[index: string]: any}) {
    super(message);
    Object.setPrototypeOf(this, InvalidJSONFormatError.prototype);
    this.json = json;
  }

  printErrorDescription() {
    console.log("message: ", this.message);
    console.log("invalid JSON: ", this.json);
  }

}

export default InvalidJSONFormatError;
